import { render, staticRenderFns } from "./IdeaListing.vue?vue&type=template&id=598ebb16&scoped=true"
import script from "./IdeaListing.vue?vue&type=script&lang=js"
export * from "./IdeaListing.vue?vue&type=script&lang=js"
import style0 from "./IdeaListing.vue?vue&type=style&index=0&id=598ebb16&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598ebb16",
  null
  
)

export default component.exports